<template>
	<div id="contentList">
		<CreateContentItem v-bind:type="contentType" v-if="editable"/>
		<div v-bind:key="slide.id" v-for="slide in contentList">
			<ContentItem v-bind:slide="slide"
						 v-bind:isEditable="editable"
						 v-bind:isDraggable="draggable"
						 v-bind:type="contentType"/>
		</div>
	</div>
</template>

<script>
	import ContentItem from './ContentItem.vue';
	import CreateContentItem from './CreateContentItem.vue';

	export default {
		name: "ContentList",
		components: {
			ContentItem,
			CreateContentItem
		},
		props: [
			"contentList",
			"contentType",
			"editable",
			"draggable"
		],
		created() {
			//console.log("create new content that is editable: "+this.editable);
		}
	}
</script>

<style scoped>
	#contentList {
		display: flex;
		flex-wrap: wrap;
		flex: 1 1 auto;
		height: 0; /* horrible hack */
		justify-content: flex-start;
		align-content: flex-start;
		overflow-y: auto;
	}
</style>